const ResponseMessages = {
  phone_number_invalid: "Phone number is invalid.",
  unknown: "Oops! Something went wrong...",
};

export function getErrorMessage(err) {
  const key = err?.response?.data?.message || "unknown";
  return ResponseMessages[key];
}

export const MESSAGES = {
  ELEMENT_ADDED: "Element was successfully added",
  ELEMENT_UPDATED: "Element was successfully updated",
  ELEMENT_DELETED: "Element was successfully deleted",
  ELEMENT_NOT_FOUND: "Element was not found",
  ELEMENT_COLOR_REQUIRED: "Element color is required",
  ELEMENT_COLOR_INVALID: "Element color is invalid",
  ELEMENT_FILE_NAME_INVALID: "Element file name is invalid",
  ELEMENT_FILE_NAME_REQUIRED: "Element file name is required",
  ELEMENT_FILE_SIZE_REQUIRED: "Element file size is required",
  ELEMENT_FILE_SIZE_INVALID: "Element file size is invalid",
  ELEMENT_LINKED_ID_INVALID: "Element linked id is invalid",
  ELEMENT_HELPER_TEXT_INVALID: "Element helper text is invalid",
  ELEMENT_HELPER_TEXT_REQUIRED: "Element helper text is required",
  ELEMENT_ICON_LINK_INVALID: "Element icon link is invalid",
  ELEMENT_ICON_LINK_REQUIRED: "Element icon link is required",
  ELEMENT_ICON_NAME_INVALID: "Element icon name is invalid",
  ELEMENT_ICON_NAME_REQUIRED: "Element icon name is required",
  ELEMENT_ID_INVALID: "Element id is invalid",
  ELEMENT_ID_REQUIRED: "Element id is required",
  ELEMENT_LINK_DESTINATION_INVALID: "Element link destination is invalid",
  ELEMENT_LINK_DESTINATION_REQUIRED: "Element link destination is required",
  ELEMENT_METHOD_INVALID: "Element method is invalid",
  ELEMENT_METHOD_REQUIRED: "Element method is required",
  ELEMENT_POSITIONING_INVALID: "Element positioning is invalid",
  ELEMENT_POSITIONING_REQUIRED: "Element positioning is required",
  ELEMENT_SCOPE_INVALID: "Element scope is invalid",
  ELEMENT_SCOPE_REQUIRED: "Element scope is required",
  ELEMENT_SHAPE_INVALID: "Element shape is invalid",
  ELEMENT_SHAPE_REQUIRED: "Element shape is required",
  ELEMENT_SHOW_TEXT_INVALID: "Element show text is invalid",
  ELEMENT_SHOW_TEXT_REQUIRED: "Element show text is required",
  ELEMENT_SIZE_INVALID: "Element size is invalid",
  ELEMENT_SIZE_REQUIRED: "Element size is required",
  ELEMENT_STATUS_INVALID: "Element status is invalid",
  ELEMENT_STATUS_REQUIRED: "Element status is required",
  ELEMENT_TEXT_COLOR_INVALID: "Element text color is invalid",
  ELEMENT_TEXT_COLOR_REQUIRED: "Element text color is required",
  ELEMENT_TITLE_INVALID: "Element title is invalid",
  ELEMENT_TITLE_REQUIRED: "Element title is required",
  ELEMENT_TYPE_INVALID: "Element type is invalid",
  ELEMENT_TYPE_REQUIRED: "Element type is required",
  ELEMENT_URL_INVALID: "Element url is invalid",
  ELEMENT_URL_REQUIRED: "Element url is required",
  ELEMENT_X_FRAME_OPTIONS_INVALID: "Element xFrameOptions is invalid",
  ELEMENT_X_FRAME_OPTIONS_REQUIRED: "Element xFrameOptions is required",
};
